/**
 * =============================================================================
 * setera-web
 * =============================================================================
 * Copyright (c) 2026 HG Digital/Setera
 * Todos os direitos reservados.
 *
 * Este software é confidencial e de propriedade da HG Digital/Setera.
 * Seu uso está sujeito aos termos do contrato de licença.
 * -----
 * Criado em : 18-08-2026 11:18:04
 * Autor     : Diego Brock
 * Projeto   : setera-web
 * Versão    : 1.0.0
 * =============================================================================
 */

import { Injectable } from '@angular/core';

/**
 * Store one-shot do token de step-up (paridade com createStepUpTokenStore do admin).
 * O token é consumido na próxima requisição em `kc-auth`.
 */
@Injectable({ providedIn: 'root' })
export class StepUpTokenStore {
  private token: string = null;

  /**
   * Guarda o token de step-up para a próxima chamada autenticada.
   *
   * @param value access_token retornado por /auth/step-up
   */
  set(value: string): void {
    this.token = value;
  }

  /**
   * Lê e descarta o token (uso único).
   *
   * @returns token atual ou null
   */
  getAndClear(): string {
    const current = this.token;
    this.token = null;
    return current;
  }

  /**
   * Lê o token sem consumir.
   *
   * @returns token atual ou null
   */
  peek(): string {
    return this.token;
  }

  /**
   * Remove o token pendente.
   */
  clear(): void {
    this.token = null;
  }
}
